import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Week } from './Week';
import { People } from './People';

export function TeamRoutes() {
  return (
    <ProjectScope
      storageKey="munin.team.project"
      emptyBody="Papan mingguan dibaca dari programme sebuah proyek. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/week" element={<Week projectId={projectId} />} />
          <Route path="/people" element={<People projectId={projectId} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
